import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import ActiveBar from '../ActiveBar'

import { CardOuter, Card } from './Card.styles'

const InfCard = forwardRef((props, ref) => (
  <CardOuter
    onClick={props.handleMove}
    ref={ref}
    className={props.isActive ? `active` : ``}
  >
    <ActiveBar />
    <Card>
      <p className="head">{props.head}</p>
      <p className="sub">{props.sub}</p>
    </Card>
  </CardOuter>
))

InfCard.defaultProps = {
  head: '01. Lorem',
  icon: null,
  sub: 'Lorem ipsum durem dolor',
}

InfCard.propTypes = {
  head: PropTypes.string,
  sub: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
}

export default InfCard
